import { createApi } from '@reduxjs/toolkit/query/react'

import { customFetchBaseQuery } from '../app/baseQuery'
import type {
  FindLocationsRequest,
  FindLocationsResponse,
} from '../../types/patient-api-gateway/api/patient/v1/patient_gateway_service'

export const cityScreenApi = createApi({
  reducerPath: 'cityScreenApi',
  baseQuery: customFetchBaseQuery,
  tagTypes: ['City'],
  endpoints: (builder) => ({
    findLocations: builder.query<FindLocationsResponse, FindLocationsRequest>({
      query: ({ name, types, pageSize, pageToken }) => ({
        url: '/api.patient.v1.PatientGatewayService/FindLocations',
        method: 'POST',
        body: {
          name,
          types,
          pageSize,
          pageToken,
        } satisfies FindLocationsRequest,
      }),
      extraOptions: {
        maxRetries: 3,
      },
      providesTags: ['City'],
      keepUnusedDataFor: 120,
    }),
  }),
})

export const { useFindLocationsQuery } = cityScreenApi
